import React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { useLocation } from 'react-router-dom';
import { Typography } from '@mui/material';
import { colors } from 'styles/colors';
import { BreadCrumpType, RoutesType } from 'models/enum';

const BreadCrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  const getTitleType = (type: string) => {
    switch (type.toLowerCase()) {
      case RoutesType.moderate.toLowerCase():
        return BreadCrumpType.moderate;
      case RoutesType.cms.toLowerCase():
        return BreadCrumpType.cms;
      case RoutesType.sendInvite.toLowerCase():
        return BreadCrumpType.sendInvite;
      case RoutesType.broadcast.toLowerCase():
        return BreadCrumpType.broadcast;
      case RoutesType.deletedUsers.toLowerCase():
        return BreadCrumpType.deletedUsers;
      case RoutesType.accountSettings.toLowerCase():
        return BreadCrumpType.accountSettings;
      case RoutesType.roles.toLowerCase():
        return BreadCrumpType.roles;
      default:
        return BreadCrumpType.dashboard;
    }
  };

  const currentPage = pathnames[pathnames.length - 1] || RoutesType.dashboard;

  return (
    <Breadcrumbs aria-label="breadcrumb">
      <Typography
        className="bodyTextBold"
        color={colors.text.primaryTheme}
        sx={{
          textTransform: 'capitalize'
        }}
      >
        {getTitleType(currentPage)}
      </Typography>
    </Breadcrumbs>
  );
};

export default BreadCrumbs;
